import Request from './request'

const DiadocDocument  = {
  getDiadocDocumentList(params, callback) {
    Request.get('diadoc-document/index', params).then(callback).catch(this.bad_answer)
  },
  getAuthStatusDiadoc(callback) {
    Request.get('diadoc-document/auth-status').then(callback).catch(this.bad_answer)
  },
  getAuthStart(callback) {
    Request.get('diadoc-document/auth-start').then(callback).catch(this.bad_answer)
  },
  postAuthCode(params, callback) {
    Request.post('diadoc-document/proove-auth', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  updateDiadocDocumentList(callback) {
    Request.get('diadoc-document/document-list').then(callback).catch(this.bad_answer)
  },
  getDiadocDocument(id, callback) {
    Request.get('diadoc-document/view/' + id).then(callback).catch(this.bad_answer)
  },
  getDiadocCounterpartList(callback) {
    Request.get('diadoc-document/counteragents-list').then(callback).catch(this.bad_answer)
  },
  getDiadocDepartmentList(callback) {
    Request.get('diadoc-document/departments-list').then(callback).catch(this.bad_answer)
  },
}

export default DiadocDocument
